import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {
  RATE_TYPE_FIXED, RATE_TYPE_PER_MONTH,
  RATE_TYPE_FREE, RATE_TYPE_PER_CLASS, RATE_TYPE_PER_HOUR, INACTIVE_STATUS, STATUS_INACTIVE,
  ACTIVE_STATUS, STATUS_ACTIVE, STATUS_DELETE, STATUS_DELETED, SUSPEND_STATUS, STATUS_SUSPENDED,
  STATUS_COMPLETE, COMPLETE_STATUS, CANCEL_STATUS, STATUS_CANCELLED, BATCH_STATUS_DELETE, BATCH_STATUS_DELETED

} from 'src/app/constants';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Address } from 'ngx-google-places-autocomplete/objects/address';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  searchLocationSubject = new BehaviorSubject<Address>(null)
  searchLocationOb$ = this.searchLocationSubject.asObservable()

  constructor(private cookieService: CookieService) {



  }

  setSearchLocation(location: Address) {
    this.searchLocationSubject.next(location);
  }


  getToken() {


    return this.cookieService.get("token_data");

  }

  setToken(token_data) {
    //return localStorage.setItem("token_data",token_data);
    return this.cookieService.set("token_data", token_data), { expires: 2, path: '/', secure: true, sameSite: 'Lax' };
  }

  getUserID() {
    return this.cookieService.get("userID");
  }
  setUserID(userID) {
    return this.cookieService.set("userID", userID), { expires: 2, path: '/', secure: true, sameSite: 'Lax' };
  }
  getHostID() {
    return this.cookieService.get("hostID");
  }
  setHostID(hostID) {
    return this.cookieService.set("hostID", hostID), { expires: 2, path: '/', secure: true, sameSite: 'Lax' };
  }
  getEmail() {
    return this.cookieService.get("email");
  }
  setEmail(email) {
    return this.cookieService.set("email", email), { expires: 2, path: '/', secure: true, sameSite: 'Lax' };
  }

  studented_btoa(ID) {
    return window.btoa(ID);
  }

  studented_atob(ID) {
    return window.atob(ID);
  }

  getRateText(priceRateTypeId) {
    if (!priceRateTypeId) {
      return "";
    }

    if (priceRateTypeId === 1) {
      return RATE_TYPE_FIXED;
    } else if (priceRateTypeId === 2) {
      return RATE_TYPE_PER_MONTH;
    }
    else if (priceRateTypeId === 3) {
      return RATE_TYPE_FREE;
    }
    else if (priceRateTypeId === 4) {
      return RATE_TYPE_PER_CLASS;
    }
    else
      return RATE_TYPE_PER_HOUR;
  }

  groupBy(array, key) {
    // Return the end result
    return array.reduce((result, currentValue) => {
      // If an array already present for key, push it to the array. Else create an array and push the object
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
      return result;
    }, {}); // empty object is the initial value for result object
  };

  headertoken(data) {

    var token = this.studented_atob(this.getToken());

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': token
      }),
      params: data
    };
    return httpOptions;

  }

  goToLink(url: string) {
    window.open(url, "_blank");
  }

  /**
     *
     * @param time h:m:s
     *
     * e.g "22:00:00" converted to 10pm
     *
     */
  timeFormat1(time) {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      const am_pm = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
      return time[0] + ':' + time[2] + am_pm;
    }
    return '';
  }
}
